import { useGameState } from '@/hooks/useGameState'
import { bestScore } from '@/lib/history'

export function ScoreDisplay() {
  const { puzzle, record } = useGameState()
  if (!puzzle || !record) return null

  // The top score stays hidden until the day's play is made, so players have
  // to judge for themselves whether their play is good enough.
  if (!record.finished) {
    return (
      <div className="score-strip grid grid-cols-1 text-center">
        <Stat label="Best found" value={record.bestFound?.score ?? '—'} />
      </div>
    )
  }
  return (
    <div className="score-strip grid grid-cols-2 text-center">
      <Stat label="Your score" value={bestScore(record)} />
      <Stat label="Top score" value={puzzle.best_play?.score ?? '—'} />
    </div>
  )
}

function Stat({ label, value }: { label: string; value: number | string }) {
  return (
    <div className="stat">
      <div className="stat-label">{label}</div>
      <div className="stat-value tabular-nums">{value}</div>
    </div>
  )
}
